import templateMeta1 from '../Templates/Classic Template/template_meta.json'
import templateMeta2 from '../Templates/Pizza Restaurant/template_meta.json'
import templateMeta3 from '../Templates/Sushi Restaurant/template_meta.json'

import classicScreenshot from '../Templates/Classic Template/screenshot.jpg'
import pizzaScreenshot from '../Templates/Pizza Restaurant/screenshot.jpg'
import sushiScreenshot from '../Templates/Sushi Restaurant/screenshot.jpg'

const templates = [
	{
		template: 'Classic Template',
		image: classicScreenshot,
		template_meta: templateMeta1,
	},
	{
		template: 'Pizza Restaurant',
		image: pizzaScreenshot,
		template_meta: templateMeta2,
	},
	{
		template: 'Sushi Restaurant',
		image: sushiScreenshot,
		template_meta: templateMeta3,
	},
]

export default templates
